import { ManualTaskDefinition } from 'Automations/nodeDefinitions/types'
import { InvoiceUpdateReviewContent } from './components/reviewContent/InvoiceUpdateReviewContent'
import { InvoiceUpdateReviewListItemContent } from './components/listItemContent/InvoiceUpdateReviewListItemContent'

/**
 * Manual task definition for the support agent's proposed changes to a SENT
 * invoice (PO number, billing address, memo, reference). Registered under
 * `INVOICE_UPDATE_REVIEW_TYPE` in `manualReviewTasks` so it renders in the inbox
 * list (`listItemContent`) and opens the full-screen processor (`reviewContent`).
 * The details/logs preview pane is rendered by `ManualTaskPreview` via
 * `InvoiceUpdateReviewPreview`.
 */
export const invoiceUpdateReviewManualTask: ManualTaskDefinition = {
  reviewContent: InvoiceUpdateReviewContent,
  listItemContent: InvoiceUpdateReviewListItemContent
}
